import { catchError, throwError } from 'rxjs';
import { getRoute } from '@/app/core/api/routes';
import { PageConfigInterface } from '@/app/features/page-config';

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { AuthService } from '@/app/core/services/auth/auth.service';

import { UserInterface } from '@/app/shared/interfaces/user.interface';
import { ResponseInterface } from '@/app/shared/interfaces/response.interface';

@Injectable({
  providedIn: 'root',
})
export class PageConfigService {
  public user: UserInterface | null = null;

  constructor(
    private readonly httpClient: HttpClient,
    private readonly authService: AuthService,
  ) {
    this.user = this.authService.user();
  }

  public getPageConfig(userId?: number, loadAsAdmin: boolean = false) {
    const actionUser = getRoute('page-config');
    const actionAdmin = getRoute('admin.page-config', { userId });
    const action = loadAsAdmin ? actionAdmin : actionUser;
    return this.httpClient.get<ResponseInterface<PageConfigInterface>>(action, {}).pipe(
      catchError((error) => {
        return throwError(() => error);
      }),
    );
  }

  public updatePageConfig(body: any, userId?: number, loadAsAdmin: boolean = false) {
    const actionUser = getRoute('page-config');
    const actionAdmin = getRoute('admin.page-config', { userId });
    const action = loadAsAdmin ? actionAdmin : actionUser;
    return this.httpClient.put<ResponseInterface<PageConfigInterface>>(action, body).pipe(
      catchError((error) => {
        return throwError(() => error);
      }),
    );
  }
}
